type BadgeVariant = 'hazard' | 'hot' | 'cobalt' | 'ink'

interface SectionHeaderProps {
  number: string
  variant: BadgeVariant
  titlePrimary: string
  titleSecondary: string
  subtitle: string
  metaLines: [string, string, string]
}

const BADGE: Record<BadgeVariant, string> = {
  hazard: 'bg-hazard text-ink',
  hot: 'bg-hot text-paper',
  cobalt: 'bg-cobalt text-paper',
  ink: 'bg-ink text-paper',
}

const SectionHeader = ({
  number,
  variant,
  titlePrimary,
  titleSecondary,
  subtitle,
  metaLines,
}: SectionHeaderProps) => (
  <div className="grid grid-cols-1 md:grid-cols-[auto_1fr_auto] gap-8 items-start mb-12">
    <div className={`${BADGE[variant]} font-display-cond text-[64px] md:text-[120px] leading-none px-4`}>
      {number}
    </div>
    <div className="text-left">
      <h2 className="font-display font-extrabold uppercase text-[clamp(40px,5vw,84px)] leading-none text-ink">
        {titlePrimary}{' '}
        <span className="font-serif italic font-normal normal-case">{titleSecondary}</span>
      </h2>
      <p className="font-serif italic text-[18px] text-ink-dim max-w-[680px] mt-3">{subtitle}</p>
    </div>
    <div className="font-mono text-[11px] uppercase text-right leading-[1.7] text-ink-dim self-end">
      {metaLines[0]}
      <br />
      {metaLines[1]}
      <br />
      {metaLines[2]}
    </div>
  </div>
)

export default SectionHeader
